/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import NavBar, { NavBarProps } from '../NavBar/NavBar';

const pageWrapperSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  backgroundColor: theme.palette.background.paper,
  position: 'relative',
  width: '100%',
  height: '100%',
});

const constantColSx: SxProps = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  width: '100%',
  height: '100%',
};

const mainContentSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(2),
  width: '100%',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
});

interface PageWrapperProps extends NavBarProps {
  customPageWrapperSx?: { [key: string]: any };
  children: React.ReactNode;
  navBarRef?: React.RefObject<any>;
}

const PageWrapper: React.FC<React.PropsWithChildren<PageWrapperProps>> = (props) => {
  const {
    pageTitle,
    customPageWrapperSx,
    children,
    rightMenuItems,
    navBarRef,
  } = props;

  return (
    <Box
      sx={[pageWrapperSx, { ...(customPageWrapperSx && customPageWrapperSx) }]}
    >
      <Box sx={constantColSx}>
        <NavBar
          pageTitle={pageTitle}
          rightMenuItems={rightMenuItems}
          navBarRef={navBarRef}
        />
        <Box sx={mainContentSx}>{children}</Box>
      </Box>
    </Box>
  );
};

export default PageWrapper;
